// extracted by mini-css-extract-plugin
module.exports = {"newDispute":"newDispute_newDispute__WBgEF","top":"newDispute_top__27-84","midSection":"newDispute_midSection__3HQjj","actions":"newDispute_actions__3GVt1"};